import { createContext, useContext, useState } from "react";

const SurveyContext = createContext();

export function BusinessSurveyProvider({ children }) {
  const [surveyData, setSurveyData] = useState({});

  const updateSurveyData = (updates) => {
    setSurveyData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  return (
    <SurveyContext.Provider value={{ surveyData, updateSurveyData }}>
      {children}
    </SurveyContext.Provider>
  );
}

export const useSurvey = () => useContext(SurveyContext);
